import React from 'react'

const Page404 = (): JSX.Element => {
  return <div>404</div>
}

export default Page404
